import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { Icon } from '../icon/icon';
import { arrowPrev, arrowNext } from '../../icons';
import { Text } from '../../new-libby';
import * as classNames from 'classnames';
import { Tooltip } from '../';
export var paginationKey = 'pagination';
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setGetVisiblePages = function () {
            var props = _this.props;
            var lowerBound = props.page - 2;
            var upperBound = props.page + 2;
            var rightPadding = lowerBound < 1 ? Math.abs(lowerBound) + 1 : 0;
            var leftPadding = upperBound > props.numPages ? upperBound - props.numPages : 0;
            var visiblePages = [];
            for (var i = lowerBound - leftPadding; i <= upperBound + rightPadding; i++) {
                if (i > 0 && i <= props.numPages) {
                    visiblePages.push(i);
                }
            }
            return visiblePages;
        };
        _this.goNextPage = function () {
            if (_this.props.page < _this.props.numPages) {
                _this.props.onPageClick(_this.props.page + 1);
            }
        };
        _this.goPrevPage = function () {
            if (_this.props.page > 1) {
                _this.props.onPageClick(_this.props.page - 1);
            }
        };
        _this.getPageNumCompByPageNum = function (page) {
            var onPageClick = function () {
                _this.props.onPageClick(page);
            };
            var disabled = _this.props.disabled;
            return (React.createElement(Text, { type: 'ts', onClick: !disabled ? onPageClick : undefined, key: page, color: !disabled ? undefined : 't50', className: classNames('page page-' + page, { current: _this.props.page === page }, { disabled: !!disabled }) }, page));
        };
        return _this;
    }
    Pagination.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var color = !props.disabled ? undefined : 't50';
        var visiblePages = this.setGetVisiblePages();
        var forceShowFirstPage = visiblePages.indexOf(1) === -1;
        var forceShowLastPage = visiblePages.indexOf(props.numPages) === -1;
        var isFirstPage = props.page === 1;
        var isLastPage = props.page === props.numPages;
        var paginationComp;
        if (props.numPages > 1) {
            var paginationFirstPage = forceShowFirstPage ? this.getPageNumCompByPageNum(1) : '';
            var firstDivider = forceShowFirstPage && visiblePages[0] - 1 !== 1 ?
                (React.createElement(Text, { type: 'ts', color: color, className: 'divider' }, ". . .")) : '';
            var lastDivider = forceShowLastPage && visiblePages[visiblePages.length - 1] + 1 !== props.numPages ?
                (React.createElement(Text, { type: 'ts', color: color, className: 'divider' }, ". . .")) : '';
            var paginationLastPage = forceShowLastPage ? this.getPageNumCompByPageNum(props.numPages) : '';
            var paginationPages = visiblePages.map(function (page) {
                return _this.getPageNumCompByPageNum(page);
            });
            var prevArrow = (React.createElement("div", { className: 'arrow-pagination prev-page', onClick: props.disabled ? undefined : this.goPrevPage },
                React.createElement(Icon, { icon: arrowPrev, className: this.props.page === 1 || props.disabled ? 'disabled' : '' })));
            var nextArrow = (React.createElement("div", { className: 'arrow-pagination next-page', onClick: props.disabled ? undefined : this.goNextPage },
                React.createElement(Icon, { icon: arrowNext, className: this.props.page === props.numPages || props.disabled ? 'disabled' : '' })));
            var classnames = namespacedClassnames('pagination');
            paginationComp = (React.createElement("section", { className: classnames },
                !isFirstPage ? prevArrow : null,
                paginationFirstPage,
                firstDivider,
                paginationPages,
                lastDivider,
                paginationLastPage,
                !isLastPage ? nextArrow : null));
        }
        else {
            paginationComp = null;
        }
        return props.disabled
            ? React.createElement(Tooltip, { body: props.disabled, relativeToBody: true }, paginationComp)
            : paginationComp;
    };
    return Pagination;
}(React.PureComponent));
export { Pagination };
//# sourceMappingURL=index.js.map